import React from 'react';

const workExperienceComponet  = props => {
  return (
      <div className="section-wrapper z-depth-1">
        <div className="section-icon col s12 m12 l2">
          <i className="fa fa-suitcase"/>
        </div>
        <div className="custom-content col s12 m12 l10 wow fadeIn a1" data-wow-delay="0.1s">
          <h2>Work Experience</h2>
          <div className="custom-content-wrapper wow fadeIn a8" data-wow-delay="0.4s">
            <h3>President<span> @ NLC Consulting LLC</span></h3>
            <span>February 2020 - Present</span>
            <p style={{'margin-bottom':'15px'}}>
              Custom web and application development
            </p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a8" data-wow-delay="0.4s">
            <h3>Senior Consultant<span> @ Eigen X, LLC</span></h3>
            <span>July 2019 - Present</span>
            <p style={{'margin-bottom':'15px'}}>
              Technology Consultant
            </p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a8" data-wow-delay="0.4s">
            <h3>Senior Software Engineer<span> @ Concorde, Inc</span></h3>
            <span>April 2018 - July 2019</span>
            <p style={{'margin-bottom':'15px'}}>
              Delivered new tested code every 2 weeks.
            </p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a2" data-wow-delay="0.2s">
            <h3>Sr. Web Developer<span> @ D2Creative</span></h3>
            <span>Feb 2011 - April 2018</span>
            <p style={{'margin-bottom':'15px'}}>Responsible for assisting with every aspect of web application development
              and project planning.</p>
            <p>Work closely with Technical & Creative team partners to assist in the technical aspect of web site
              design implementation</p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a3" data-wow-delay="0.3s">
            <h3>Senior Application Developer<span> @ Trinity Data Solutions, LLC</span></h3>
            <span>Jun 2015 - Mar 2017</span>
            <p style={{'margin-bottom':'15px'}}>Lead developer responsible for designing, architecting and implementing
              new modules for a multithreaded, real-time, smart client/server Laboratory Information Management
              System</p>
            <p style={{'margin-bottom':'15px'}}>Maintained schedules and assured on time delivery of major code
              releases</p>
            <p>Implemented hot fixes in production for errors identified in the code after major releases</p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a4" data-wow-delay="0.4s">
            <h3>Freelance Software Developer<span> @ Trinity Data Solutions, LLC</span></h3>
            <span>Nov 2009 - Feb 2011</span>
            <p style={{'margin-bottom':'15px'}}>Developed web-based inventory tracking system for physical warehouses:
              Inventory, Logistics, CRM, and Accounting</p>
            <p>Completed detailed programming tasks for real time cylinder tracking software</p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a5" data-wow-delay="0.4s">
            <h3>Freelance Web Developer<span> @ Practising Law Institute (PLI)</span></h3>
            <span>Sep 2009 - Nov 2009</span>
            <p style={{'margin-bottom':'15px'}}>Developed new functionality for custom internal training software</p>
            <p>Provided application support and troubleshooting</p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a6" data-wow-delay="0.4s">
            <h3>Freelance Web Developer<span> @ Heartbeat Ideas</span></h3>
            <span>May 2009 - Aug 2009</span>
            <p>Updated the functionality of a custom CMS written in ASP.NET C# with SQL Server</p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a7" data-wow-delay="0.4s">
            <h3>Freelance Web Developer<span> @ Crossborders</span></h3>
            <span>Dec 2008 - Mar 2009</span>
            <p>Internal intranet development and business operations integration</p>
          </div>
          <div className="custom-content-wrapper wow fadeIn a8" data-wow-delay="0.4s">
            <h3>Senior Application Support Analyst<span> @ SMART Business Advisory and Consulting</span></h3>
            <span>May 2006 - May 2008</span>
            <p style={{'margin-bottom':'15px'}}>Responsible for supporting an internal implementation of Changepoint PSA
              (Professional Service Automation) software.</p>
            <p style={{'margin-bottom':'15px'}}>Promoted to Senior Application Support Analyst after 6 months of
              exceptional service as Help Desk Support.</p>
            <p>Hired full time after a summer internship</p>
          </div>
        </div>
      </div>
  )
};

export default workExperienceComponet;